import { HTMLExtUtils } from '@ssml-editor/core';
import { SAY_AS_TYPE } from './constant.js';

const sayAsElementToHtml = ({
  element,
  childrenHtml
}) => {
  const { mark, interpretAs } = element;
  return HTMLExtUtils.createElementAsString(
    SAY_AS_TYPE,
    true,
    false,
    {
      mark,
      "interpret-as": interpretAs
    },
    childrenHtml
  );
};

export { sayAsElementToHtml };
//# sourceMappingURL=element-to-html.js.map
